import { Component, Input } from '@angular/core';

/** Duesy's robot mark (decorative; the surrounding control carries the label). */
@Component({
  selector: 'app-duesy-robot-icon',
  template: `
    <svg [attr.width]="size" [attr.height]="size" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <rect x="4" y="7" width="16" height="12" rx="3" stroke="currentColor" stroke-width="1.8" />
      <path d="M12 3.5V7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="3" r="1.2" fill="currentColor" />
      <circle cx="9" cy="12.5" r="1.4" fill="currentColor" />
      <circle cx="15" cy="12.5" r="1.4" fill="currentColor" />
      <path d="M9.5 16h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="M2.5 12v2.5M21.5 12v2.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </svg>
  `,
  styles: [':host { display: inline-flex; }'],
})
export class DuesyRobotIconComponent {
  @Input() size = 26;
}
